import React from 'react';
import { motion } from 'framer-motion';

const WhatsAppButton = () => {
  return (
    <motion.a 
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 2, duration: 0.5, type: "spring" }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3" 
      href="https://wa.me/919940890569" 
      target="_blank"
      rel="noopener noreferrer"
    >
      <motion.div 
        initial={{ opacity: 0, x: 20 }}
        whileHover={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
        className="bg-white text-black px-4 py-2 rounded-lg shadow-lg text-sm font-bold whitespace-nowrap hidden md:block"
      >
        Need help?
      </motion.div>
      <motion.div 
        animate={{ 
          boxShadow: [
            '0 0 0 0 rgba(34, 197, 94, 0.7)',
            '0 0 0 10px rgba(34, 197, 94, 0)',
            '0 0 0 20px rgba(34, 197, 94, 0)'
          ]
        }}
        transition={{ duration: 2, repeat: Infinity }}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg flex items-center justify-center w-14 h-14"
      >
        <i className="fa-brands fa-whatsapp text-2xl"></i>
      </motion.div>
    </motion.a>
  );
};

export default WhatsAppButton;